import React from "react";
import styled, { keyframes } from "styled-components";

// Skeleton koji prati novi overlay dizajn ProductCard-a:
// ista 3:4 kartica, tokeni, i donji info blok kao senka sadržaja.
const SkeletonProductCard = () => {
  return (
    <Card>
      <Sheen />
      <Info>
        <Line $w="62%" $h="1.6rem" />
        <Line $w="34%" $h="1.3rem" />
      </Info>
    </Card>
  );
};

export default SkeletonProductCard;

const sweep = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

const Card = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  background: var(--bg2, #17171c);
  border: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  border-radius: 0.6rem;
  overflow: hidden;
`;

const Sheen = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    transparent 30%,
    rgba(255, 255, 255, 0.045) 50%,
    transparent 70%
  );
  animation: ${sweep} 1.6s infinite;
`;

const Info = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  background: linear-gradient(0deg, rgba(10, 10, 12, 0.75), transparent);
`;

const Line = styled.div`
  width: ${({ $w }) => $w || "100%"};
  height: ${({ $h }) => $h || "1.4rem"};
  border-radius: 0.3rem;
  background: rgba(255, 255, 255, 0.07);
  animation: ${pulse} 1.6s ease-in-out infinite;
`;
